import { type EmbedViewId, getEmbedViewById } from './embedViews';
import {
  EMBED_ACCESS_TOKEN_QUERY_PARAM,
  EMBED_EXPIRES_AT_QUERY_PARAM,
  EMBED_TENANT_ID_QUERY_PARAM,
  EMBED_USER_ID_QUERY_PARAM,
} from '../app/auth/embed-auth.utils';

const ensureTrailingSlash = (value: string) =>
  value.endsWith('/') ? value : `${value}/`;

export const buildEmbedUrl = ({
  accessToken,
  baseUrl,
  expiresAt,
  queryParams,
  tenantId,
  userId,
  viewId,
}: {
  accessToken?: string | null;
  baseUrl: string;
  expiresAt?: string | null;
  queryParams?: Record<string, string | null | undefined>;
  tenantId?: string | null;
  userId?: string | null;
  viewId: EmbedViewId;
}) => {
  const view = getEmbedViewById(viewId);
  const url = new URL(
    view.examplePath.replace(/^\//, ''),
    ensureTrailingSlash(baseUrl)
  );

  if (accessToken) {
    url.searchParams.set(EMBED_ACCESS_TOKEN_QUERY_PARAM, accessToken);
  }

  if (tenantId) {
    url.searchParams.set(EMBED_TENANT_ID_QUERY_PARAM, tenantId);
  }

  if (userId) {
    url.searchParams.set(EMBED_USER_ID_QUERY_PARAM, userId);
  }

  if (expiresAt) {
    url.searchParams.set(EMBED_EXPIRES_AT_QUERY_PARAM, expiresAt);
  }

  for (const [key, value] of Object.entries(queryParams ?? {})) {
    if (!value) continue;
    url.searchParams.set(key, value);
  }

  return url.toString();
};
